async function request(endpoint, method = 'GET', data = null) {
    const apiUrl = process.env.REACT_APP_RAG_API_URL;
    const url = `${apiUrl}${endpoint}`;
    const options = {
        method,
        headers: {
            'Content-Type': 'application/json',
        },
    };

    if (data) {
        options.body = JSON.stringify(data);
    }

    try {
        const response = await fetch(url, options);
        if (!response.ok) {
            console.error(`HTTP error! status: ${response.status} for ${url}`);
            return null; // O manejar el error como prefieras
        }
        return await response.json();
    } catch (error) {
        console.error('Fetch error:', error);
        return null; // O manejar el error
    }
}

export const ragApi = {
    get: (endpoint) => request(endpoint, 'GET'),
    post: (endpoint, data) => request(endpoint, 'POST', data),
};
